import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import './madalConfirm.scss';
export const ConfirmTip = (props) => {
    Modal.confirm({
        autoFocusButton: null,
        icon: props.icon || <ExclamationCircleOutlined style={{ color: 'red' }}></ExclamationCircleOutlined>,
        title: <b>{props.title}</b> || <b>提示</b>,
        content: props.content || '',
        onOk: props.onOk || (() => {}),
        okText: props.okText || '确定',
        cancelText: props.cancelText || '取消',
        closable: props.closable || true,
        width: 500,
        style: { top: '25%' },
        ...props
    });
};
